<script setup>
/**
 * Este objeto hay que meterlo dentro de un objeto Tabla para que le provea
 * de los datos necesarios
 */
import { inject } from 'vue';

const props = defineProps({
  // Nombre del campo para filtrar
  campo: { type: String, required: true },
  valores: { type: Array, default: () => [] },
});

// Tabla nos publica este objeto reactivo
const filtros = inject('filtros');

function cambiaValor(event) {
  // Actualizamos el filtro con el valor seleccionado
  filtros[props.campo] = event.target.value;
}
</script>

<template>
  <th>
    <select :class="`filtro-${props.campo}`" @change="cambiaValor">
      <option value=""></option>
      <option v-for="valor in valores" :key="valor" :value="valor">
        {{ valor }}
      </option>
    </select>
  </th>
</template>

<style scoped lang="scss">
@import "@/../assets/stylesheets/cifra/vars/main.scss";

th {
  white-space: nowrap;
  select {
    font-weight: normal;
  }
}
</style>
